module.exports = __webpack_public_path__ + "media/customizations/moonlight/logo-fdc6e3f31df08a79d6da7610835bee58.png";